import { useState, useEffect } from "react";
import "./chapter-item.css";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import { PiReadCvLogoDuotone, PiClockCountdownDuotone } from "react-icons/pi";
import { VscDebugStart } from "react-icons/vsc";
import Button from "../../../../ui/atoms/buttons/Button";
import StatusComponent from "../../../../ui/atoms/status/StatusComponent";
import {
  convertDuration,
  capitalizeAll,
  isEmpty,
} from "../../../../core/utils/helpers";
import { useNavigate } from "react-router-dom";
import { schoolSlice } from "../../../../app/store/slices/schoolSlice";
import { useDispatch } from "react-redux";

const ChapterItem = ({
  chapter,
  selectedChapterId,
  selectedLessonId,
  onSelectChapter,
  onSelectLesson,
  forceOpenChapterId,
  onRelease,
  onArchive,
}) => {
  const navigate = useNavigate();
  const [isChapterDetails, setIsChapterDetails] = useState(false);

  // const isSelectedChapter = chapter.id === selectedChapterId;

  const chapter_id = chapter?.id;
  const chapter_title = capitalizeAll(chapter?.title);
  const chapter_description = chapter?.description;
  const lessons = chapter?.lessons;
  const timing = chapter?.chapter_timing;
  const is_activated = chapter?.is_activated;
  const is_deleted = chapter?.is_deleted;

  const dispatch = useDispatch();

  // Forcer l'ouverture si forceOpenChapterId correspond à ce chapitre
  useEffect(() => {
    if (forceOpenChapterId === chapter.id) {
      setIsChapterDetails(true);
    }
  }, [forceOpenChapterId, chapter.id]);

  return (
    <div className="chapter-item">
      <div
        className={`ch-i-header ${selectedChapterId === chapter_id ? "is_selected" : ""}`}
        onClick={() => {
          // toggle seulement si l'utilisateur clique directement
          setIsChapterDetails((prev) => !prev);

          // si on clique sur le chapitre → première lesson
          // const firstLesson = chapter.lessons?.[0];
          // if (firstLesson) {
          //   onSelectChapter(chapter, firstLesson);
          // }
        }}
      >
        <div className="ch-i-h-l">
          <h1>{chapter_title}</h1>
          <div className="d-flex gap-md">
            <div className="tile">
              <PiReadCvLogoDuotone className="icon" />
              <span>
                {lessons?.length + " "}
                {lessons?.length > 1 ? "lessons" : "lesson"}
              </span>
            </div>
            <div className="tile">
              <PiClockCountdownDuotone className="icon" />
              <span>{convertDuration(timing)}</span>
            </div>
          </div>
        </div>
        <div className="ch-i-h-r">
          {isChapterDetails ? (
            <IoIosArrowUp className="icon" />
          ) : (
            <IoIosArrowDown className="icon" />
          )}
        </div>
      </div>
      {isChapterDetails && (
        <div className="ch-i-content">
          <div className="w-full d-flex gap-xs">
            <StatusComponent
              type={is_activated ? "success" : "error"}
              title={`Chapter ${is_activated ? "Released" : "UnReleased"}`}
            />
            <StatusComponent
              type={is_deleted ? "error" : "success"}
              title={`Chapter ${is_deleted ? "Archived" : "UnArchived"}`}
            />
          </div>
          <p className="chapter-resume mt-xs mb-xs">{chapter_description}</p>
          <div className="w-full d-flex gap-xs">
            <Button
              type={"button"}
              preferedStyle={"normal"}
              title={"📄 Add lesson"}
              action={() => {
                dispatch(schoolSlice.actions.onCurrentChapter(chapter));
                navigate(
                  `/admin/schools/streams/courses/chapters/${chapter_id}/lessons/create`,
                );
              }}
            />
            <Button
              type={"button"}
              preferedStyle={"default"}
              title={`${
                is_activated ? "Click to UnReleased" : "Click to Released"
              }`}
              action={() => onRelease()}
            />
            <Button
              type={"button"}
              preferedStyle={"default"}
              title={`${
                is_deleted ? "Click to UnArchived" : "Click to Archived"
              }`}
              action={() => onArchive()}
            />
          </div>
          <div className="chapter-lessons">
            {isEmpty(lessons) ? (
              <div className="w-full p-md">
                <span style={{ fontSize: "1rem", color: "grey" }}>
                  No lesson available yet for this chapter!
                </span>
              </div>
            ) : (
              lessons?.map((lesson) => (
                <div
                  className={`lesson-item ${
                    selectedLessonId === lesson.id ? "is_selected" : ""
                  }`}
                  key={lesson.id}
                  onClick={() => onSelectLesson(chapter.id, lesson)}
                >
                  <VscDebugStart className="icon" />
                  <div className="les-it-col">
                    <h2>{capitalizeAll(lesson?.title)}</h2>
                    <div className="d-flex align-center">
                      <PiClockCountdownDuotone className="icon" />
                      <span>{convertDuration(lesson?.timing)}</span>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ChapterItem;
